import { IOMaterialDetailsByPID } from "@redux/reducers/otherMaterialReduser";

export enum ActionType {
  OTHER_MATERIALS_DETAILS_BY_PID = "OTHER_MATERIALS_DETAILS_BY_PID",
}

export interface IOtherMaterialDetailsByPid {
  type: ActionType.OTHER_MATERIALS_DETAILS_BY_PID;
  payload: IOMaterialDetailsByPID[];
}

export type Action = IOtherMaterialDetailsByPid;
